import { useEffect, useRef } from 'react';
import { playNotificationSound } from '../services/notificationSound';
import { useNotificationSetting } from './useNotificationSetting';

// รอบตรวจ — ตรวจถี่กว่าช่วงเวลาที่ตั้งไว้ เพื่อให้เสียงดังใกล้เคียงเวลาจริง
const TICK_MS = 1000;

/**
 * เตือนเมื่อมีเคส "ถูกมอบหมายมาแล้วแต่ยังไม่กด Start" ค้างเกินเกณฑ์
 *
 * ดังซ้ำเรื่อย ๆ ตามรอบที่ admin ตั้งไว้ จนกว่าจะไม่มีเคสค้างแล้ว
 * นับอายุจาก createdate เทียบกับเวลาของ "เบราว์เซอร์" ไม่ใช่ NOW() ของ MySQL
 * เพราะ MySQL รันบน UTC ส่วนคอลัมน์เวลาเก็บเป็นเวลาไทย ต่างกัน 7 ชม.
 *
 * @param {Array} waitingCases เคสของฉันที่ยังไม่ได้เริ่ม (status = Waiting)
 */
export const useHoldTooLongAlert = (waitingCases) => {
  const { byType } = useNotificationSetting();
  const setting = byType('hold_too_long');

  // เก็บใน ref เพื่อให้ interval อ่านค่าล่าสุดได้โดยไม่ต้อง re-create timer ทุก render
  const casesRef = useRef(waitingCases);
  const settingRef = useRef(setting);
  const lastPlayedAt = useRef(0);

  casesRef.current = waitingCases;
  settingRef.current = setting;

  useEffect(() => {
    const timer = setInterval(() => {
      const s = settingRef.current;
      if (!s || s.enabled === false) return;

      const thresholdMs = (s.thresholdSeconds ?? 120) * 1000;
      const repeatMs = (s.repeatSeconds ?? 10) * 1000;

      const list = casesRef.current || [];
      const now = Date.now();

      // มีเคสค้างเกินเกณฑ์อย่างน้อย 1 ใบก็พอ — ไม่ดังทีละใบ ไม่งั้นเสียงทับกันมั่ว
      const overdue = list.some((c) => {
        const at = c?.createdate ? new Date(c.createdate).getTime() : NaN;
        if (Number.isNaN(at)) return false;
        return now - at >= thresholdMs;
      });

      if (!overdue) return;
      if (now - lastPlayedAt.current < repeatMs) return;

      lastPlayedAt.current = now;
      playNotificationSound({
        soundUrl: s.soundUrl,
        volume: s.volume ?? 0.8,
        urgent: true,
      });
    }, TICK_MS);

    return () => clearInterval(timer);
  }, []);
};

export default useHoldTooLongAlert;
